import { httpGet } from './api/axios_api';
import Constants from '../constants/constants';
import actions from './splitIO_actions';

export function getSplitIOTreatments(featureName, trafficType) {
  return async (dispatch) => {
    const url = encodeURI(`${Constants.BACKEND_URL}/splitio/${trafficType}/${featureName}`);
    return httpGet(url, {}).then((response) => {
      if (typeof response !== 'undefined') {
        if (response.data.success) {
          dispatch({
            type: actions.getSplitIOTreatments,
            treatment: response.data.treatment,
          });
        }
      }
    });
  };
}

export async function getTreatmentAsync(featureName, trafficType) {
  const url = `${Constants.BACKEND_URL}/splitio/${trafficType}/${featureName}`;

  return httpGet(url, {});
}
